<p>test-input-activity-editor works!</p>
